import { SvgIconProps } from "@mui/material";
import React from "react";
import { AllInboxRounded } from "@mui/icons-material";

const ChatIcon = (props: SvgIconProps) => {
  return <AllInboxRounded />;
};
export default ChatIcon;
